import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import styles from "assets/jss/material-kit-react/views/landingPageSections/aboutStyle.js";
import AboutText from "./AboutText";
import "../../../assets/scss/general.scss";

const useStyles = makeStyles(styles);
const images = [
  require("assets/img/kvinneOgBarn.png"),
  require("assets/img/bulldosingAvHjem.jpg"),
  require("assets/img/barn_gjerde.jpg"),
  require("assets/img/barn.jpg"),
];

const imageCredits = [
  "Simen Aker Grimsrud",
  "Mamoun Wazaz/NTB",
  "Hamde Abu Rahma",
  "Ingunn Eriksen",
];

const imageAltsNo = [
  "en kvinne med tre barn står i en sliten gang",
  "en bulldoser river ned et hjem mens folk ser på",
  "to barn som står mellom et gitter gjerde og smiler til hverandre",
  "tre barn med ryggsekker går ned et smug",
];
const imageAltsEng = [
  "a woman with three children standing in a makeshift hallway",
  "a bulldoser tearing down a home while people watch",
  "two children standing between a wired fence, smiling at eachother",
  "three children with backpacks walking down an alleyway",
];

const AboutSection = ({ english, ids }) => {
  const classes = useStyles();

  return (
    <div className={classes.imgContainer}>
      {ids.map((id, index) => (
        <div key={id}>
          <AboutText
            english={english}
            section={id}
            imageSource={images[index]}
            imageCredit={imageCredits[index]}
            imageAlt={english ? imageAltsEng[index] : imageAltsNo[index]}
          />
        </div>
      ))}
    </div>
  );
};

AboutSection.propTypes = {
  english: PropTypes.bool,
};

export default AboutSection;
